import Filter from "./Filter";

const FilterListItems = ({
    filters,
    inputContainerFilterClass,
    deleteProfanityFilter,
    updateProfanityFilter,
}) => {
    let arr = [];
    filters.forEach((item, i) => {
        let animationDisplay = i % 2 === 0 ? true : false;

        arr.push(
            <Filter
                filterText={item.filterText}
                key={item.id}
                item={item}
                animationLeft={animationDisplay}
                animationRight={!animationDisplay}
                inputContainerFilterClass={inputContainerFilterClass}
                updateProfanityFilter={updateProfanityFilter}
                deleteProfanityFilter={deleteProfanityFilter}
            />,
        );
    });
    return <>{arr}</>;
};

export default FilterListItems;
